"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURES_FROM_SERVER = exports.UNSUBSCRIBE_FROM_FEATURE = exports.SUBSCRIBE_TO_FEATURE = void 0;
var SUBSCRIBE_TO_FEATURE = "SUBSCRIBE_TO_FEATURE";
exports.SUBSCRIBE_TO_FEATURE = SUBSCRIBE_TO_FEATURE;
var UNSUBSCRIBE_FROM_FEATURE = "UNSUBSCRIBE_FROM_FEATURE";
exports.UNSUBSCRIBE_FROM_FEATURE = UNSUBSCRIBE_FROM_FEATURE;
var FEATURES_FROM_SERVER = "FEATURES_FROM_SERVER";
exports.FEATURES_FROM_SERVER = FEATURES_FROM_SERVER;